import { Button } from "@/components/ui/button"
import { Dialog, DialogContent } from "@/components/ui/dialog"
import { useTrialForm } from "./useTrialForm"
import { TrialFormFields } from "./TrialFormFields"
import { toast } from 'sonner';
import { Link } from "react-router-dom"
import { useEffect } from 'react'

export function TrialFormDialog({ open, onOpenChange }) {
  const { formData, errors, isSubmitting, updateField, handleSubmit, resetForm } = useTrialForm()

  const onSubmit = (e) => {
    e.preventDefault()
    handleSubmit(() => {
      onOpenChange(false)
      resetForm()
      toast.success('Check your email for further information');
    })
  }

  useEffect(() => {
    resetForm()
  }, [open])



  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 gap-0" style={{ zIndex: 99999 }}>
        <div className="relative bg-white rounded-lg">
          <button className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"></button>
          <div className="py-[32px] px-[44px]">
            <div className="mb-6">
              <div className="flex items-center justify-center gap-2 mb-4">
                <div className="w-[160px] h-[50px] bg-[url('@/assets/images/idata-logo.gif')] bg-contain"></div>
              </div>
              <h2 className="text-center text-[30px] font-bold text-[#0066FF] mb-[20px]">Apply for a free trial</h2>
            </div>

            <form onSubmit={onSubmit} className="space-y-4">
              <TrialFormFields formData={formData} errors={errors} onFieldChange={updateField} />

              <div className="mt-[14px]">
                <div className="text-[16px] text-[#4D4D4D] leading-[24px]">
                  By submitting this information, I agree to the{" "}
                  <Link to="/privacy-policy" className="text-blue-600 hover:underline font-bold">
                    privacy policy
                  </Link>{" "}
                  and to learn more about products and services from iData.
                  <br />
                  This site is protected by reCAPTCHA and the Google Privacy Policy and{" "}
                  <Link to="/term-of-use" className="text-blue-600 hover:underline font-bold">
                    Terms of Use
                  </Link>{" "}
                  apply.
                </div>

                <Button type="submit"
                className="w-full bg-[#0066FF] h-[52px] text-[24px] text-white mt-[20px] hover:bg-[#297FFF]" disabled={isSubmitting}>
                  {isSubmitting ? "Getting Started..." : "Get Started"}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
